import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getContractPaymentModels, getPaymentCodeFromRoot } from 'modules/settings/api';

export const useQueryContractPaymentModels = () => {
  //getContractPaymentModels
  const {
    data: allContractPayment,
    isError: errContractPaymentModels,
    isLoading: isLoadingContractPaymentModels,
  } = useQuery(QUERY_KEYS.CONTRACT_PAYMENT_MODELS_ALL, getContractPaymentModels);

  const {
    data: paymentCodeOptions,
    isError: errPaymentCodeOptions,
    isLoading: isLoadingPaymentCodeOptions,
  } = useQuery(QUERY_KEYS.PAYMENT_CODE, getPaymentCodeFromRoot);

  return {
    contractPaymentModelsData: allContractPayment?.data || {},
    paymentCodeOptions: paymentCodeOptions?.data || {},
    isError: errContractPaymentModels || errPaymentCodeOptions,
    isLoading: isLoadingPaymentCodeOptions || isLoadingContractPaymentModels,
  };
};
